import {get, post} from './api';

const getCourseRecords = get('course-record/list');
const saveCourseRecord = post('course-record/save');

export {
    getCourseRecords,
    saveCourseRecord
}
